<template>
  <div class="info-container" :class="{'device-coordi': isDevicetest}">
    <div class="column-container">
      <div class="column-title">{{ $t('camstudy.coordi.roomInfo.studyTitle') }}</div>
      <div class="column-message">{{ roomTitle }}</div>
    </div>
    <div class="column-container">
      <div class="column-title">{{ $t('camstudy.coordi.roomInfo.host') }}</div>
      <img v-if="hostProfileImageUrl" class="user-profile-image" :src="hostProfileImageUrl" alt="image" />
      <div v-else class="user-image-none"></div>
      <div class="column-message">{{ hostNickname }}</div>
    </div>
    <div class="column-container">
      <div class="column-title">{{ $t('camstudy.coordi.roomInfo.capacity') }}</div>
      <div class="column-message"> {{ $t('camstudy.coordi.roomInfo.participants', {'0': maxCnt }) }}</div>
    </div>
    <div class="column-container">
      <div class="column-title">{{ $t('camstudy.coordi.roomInfo.period') }}</div>
      <div class="column-message">{{ startDate }} ~ {{ endResvDate }}</div>
    </div>
    <div class="column-container">
      <div class="column-title">{{ $t('camstudy.coordi.roomInfo.notice') }}</div>
      <div class="column-message">{{ studyContent }}</div>
    </div>
  </div>
</template>

<script>
// @todo 데이터 연결
import {mapActions} from "vuex";
import moment from "moment/moment";
import {cdnImgUrl} from "@/utils/ImageUrl";

export default {
  name: 'RoomInfo',
  props: {
    roomInfo: Object,
    camStudyRoomInfoProps: Object,
    isDevicetest: Boolean
  },
  data() {
    return {
      roomTitle: '',
      maxCnt: 0,
      hostNickname: '',
      hostProfileImageUrl: '',
      startDate: '',
      endResvDate: '',
      studyContent: '',
    }
  },
  async created() {
    const roomInfo = this.camStudyRoomInfoProps.room;
    const camStudyInfo = this.camStudyRoomInfoProps.camStudy;

    this.roomTitle = roomInfo.title || camStudyInfo.studyTitle;
    this.maxCnt = roomInfo.maxCnt;
    this.startDate = this.getFormedDate(camStudyInfo.startDate);
    this.endResvDate = this.getFormedDate(camStudyInfo.endResvDate);
    this.studyContent = camStudyInfo.studyContent;
    this.hostNickname = roomInfo.user.nickname || roomInfo.user.username;
    this.hostProfileImageUrl = roomInfo.user?.profileImagePath ? cdnImgUrl(roomInfo.user?.profileImagePath) : '';
  },
  computed: {
    getFormedDate() {
      return date => {
        return moment(date).format('YYYY-MM-DD');
      }
    },
  },
  methods: {
    ...mapActions('camstudy', ['getCamStudyRoomInfo']),
    ...mapActions('user', ['getUserInfo']),
  }
}
</script>
<style scoped lang="scss">
[grm-device-mobile]{
  .info-container {
    @media(orientation: portrait) {
      height: calc(100dvh - 100vw - 124px - 50px + 20px);
    }
    @media(orientation: landscape) {
      height: calc(100dvh - 121px);
      &.device-coordi {
        height: calc(100dvh - 171px);
      }
    }
  }
  .column-title{
    width: 100px;
    font-size: 12px;
  }
}
html:not([grm-device-mobile]){
  .info-container{
    max-height: 278px;
    height: 100%;
    &::-webkit-scrollbar{
      display: none;
    }
  }
  .column-title{
    font-size: 14px;
    width: 120px;
  }
}
.info-container{
  display: flex;
  flex-direction: column;  
  padding: 0 6px 20px;
  gap: 16px;
  color: white;
  overflow-y: scroll;

  .column-container{
    display: flex;
  }

  .column-title {
    font-weight: 700;
    line-height: 150%;
    flex-shrink: 0;
  }
  .column-message {
    font-size: 12px;
    line-height: 150%;
  }
  .user-profile-image, .user-image-none{
    width: 18px;
    height: 18px;
    border-radius: 50%;
    margin-right: 6px;
  }
  .user-image-none{
    background: url("~@/assets/images/user_profile.svg") no-repeat;
    background-size: auto 18px;
  }
}
</style>